import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";

import {
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  colors,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import Upload from "../Images/Upload";
import Thumbnail from "../Images/Thumbnail";
import ContainerLoading from "../Loading/ContainerLoading";

import useResizeableContainer from "../../hooks/useResizeableContainer";

import HttpContext from "../../contexts/HTTP/HttpContext";
import ImageContext from "../../contexts/Image/ImageContext";
import ConfigContext from "../../contexts/Config/ConfigContext";
import ModelContext from "../../contexts/Model/ModelContext";

function Home(props) {
  const theme = useTheme();
  const { get } = useContext(HttpContext);
  const { imageData } = useContext(ImageContext);
  const { config } = useContext(ConfigContext);
  const { models } = useContext(ModelContext);

  const { imagesLoading, configLoading, modelsLoading } = props;

  const containerRef = useRef(null);
  const { containerSize } = useResizeableContainer({ containerRef });

  const [selectedModel, setSelectedModel] = useState("");

  const [uploadedImages, setUploadedImages] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(models)) {
      setSelectedModel(models[0]);
    }
  }, [models]);

  return (
    <Grid
      ref={containerRef}
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Home</Typography>
          <Typography>Upload your images for annotation</Typography>
        </div>
        <div style={{ minWidth: "10em", marginTop: theme.spacing(1) }}>
          <FormControl fullWidth style={{ minWidth: "10em" }}>
            <InputLabel id="model-selection">Model</InputLabel>
            <Select
              labelId="model-selection"
              id="model-select"
              value={selectedModel}
              label="Model"
              onChange={(e) => setSelectedModel(e.target.value)}
              disabled={modelsLoading}
            >
              {models.map((model) => (
                <MenuItem value={model}>{model.displayName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={configLoading} />
      <div
        style={{ display: configLoading ? "none" : "flex", flexWrap: "wrap" }}
      >
        {uploadedImages.map((image) => {
          return (
            <Thumbnail
              key={image.name}
              size={Math.floor(containerSize.width * 0.15)}
              imageData={{ file: URL.createObjectURL(image) }}
            />
          );
        })}
        <Upload
          size={Math.floor(containerSize.width * 0.15)}
          images={uploadedImages}
          setImages={setUploadedImages}
          selectedModel={selectedModel}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginTop: theme.spacing(8),
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Recent Images</Typography>
          <Typography>
            View your recently processed images (updated automatically)
          </Typography>
        </div>
      </div>
      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={imagesLoading} />
      <div
        style={{
          display: imagesLoading ? "none" : "flex",
          flexWrap: "wrap",
        }}
      >
        {_.slice(
          imageData.processed,
          0,
          Number(_.get(config, "user.recentImageCount", 12))
        ).map((image) => {
          return (
            <Thumbnail
              key={image.file}
              size={Math.floor(containerSize.width * 0.15)}
              imageData={image}
            />
          );
        })}
      </div>
    </Grid>
  );
}

export default Home;
